import { render, staticRenderFns } from "./AmendmentsTable.vue?vue&type=template&id=21ba7348&scoped=true"
import script from "./AmendmentsTable.vue?vue&type=script&lang=js"
export * from "./AmendmentsTable.vue?vue&type=script&lang=js"
import style0 from "./AmendmentsTable.vue?vue&type=style&index=0&id=21ba7348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba7348",
  null
  
)

export default component.exports